module.exports = __webpack_public_path__ + "static/family-running-on-beach-desktop.a77b60f1.webp";